// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import ReactLoader from './../core/ReactLoader';
//import BaseAppComponent = require('./../class/BaseAppComponent');

function wrapInAppContainer(AppComponent: any) {

    return (props: any) => {
        return (
            <ReactLoader appReady={true} >
                <AppComponent {...props} />
            </ReactLoader>
        );
    };

}

export default wrapInAppContainer;